import { render, staticRenderFns } from "./MareLiberum.vue?vue&type=template&id=53dcf448&scoped=true&"
import script from "./MareLiberum.vue?vue&type=script&lang=js&"
export * from "./MareLiberum.vue?vue&type=script&lang=js&"
import style0 from "./MareLiberum.vue?vue&type=style&index=0&id=53dcf448&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dcf448",
  null
  
)

export default component.exports